import WeatherOptionState from '../store/schema/WeatherOptionState';
import WeatherEnabledStatus from 'owa-service/lib/contract/WeatherEnabledStatus';
import { mutatorAction } from 'satcheljs';
import getWeatherOption from '../store/store';

export default mutatorAction('setShowWeatherOption', function setShowWeatherOption(
    showWeatherStatus: boolean
) {
    let optionState: WeatherOptionState = getWeatherOption();
    optionState.weatherEnabled = showWeatherStatus
        ? WeatherEnabledStatus.Enabled
        : WeatherEnabledStatus.Disabled;
});
